module.exports = __webpack_public_path__ + "assets/icons/information-outline-22c7.svg";